// extracted by mini-css-extract-plugin
export default {"appContainer":"App_appContainer__RscqJ","contentWrapper":"App_contentWrapper__EeiD2"};